import { useTranslation } from "react-i18next";
import { NavButton } from "./NavButton";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(newLang);
  };

  return (
    <NavButton onClick={toggleLanguage} aria-label="Toggle language">
      {i18n.language === "es" ? "EN" : "ES"}
    </NavButton>
  );
};
